// Per-route SEO meta. React 19 hoists <title>/<meta>/<link> rendered here into
// <head>, so each page can set its own title, description, canonical and social
// tags. Constant tags (og:image, og:site_name, twitter:card) stay static in
// public/index.html.

const SITE_URL = "https://www.catchingon.co.uk";

export const Seo = ({ title, description, path = "/" }) => {
    const url = `${SITE_URL}${path}`;

    return (
        <>
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />

            {/* Open Graph */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />

            {/* Twitter */}
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
        </>
    );
};
